import styled from 'styled-components';
import { StyledComboboxContentFooterProps } from './types';
import { baseContainer } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledComboboxContentFooter = styled.div<StyledComboboxContentFooterProps>`
  ${baseContainer}
`;
